export default __webpack_public_path__ + "static/me-0b785614513a0b99de04a91166cbf603.svg";